import * as React from 'react';

import { SVGProps } from '../../types';

export const IconAnswerKeySvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    focusable="false"
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M12.728 10.6065C13.0412 10.2933 13.1076 9.8176 12.9737 9.39546C12.4541 7.75804 12.8436 5.89464 14.1422 4.59606C15.9972 2.74107 19.0047 2.74107 20.8597 4.59606C22.7147 6.45105 22.7147 9.45859 20.8597 11.3136C19.5612 12.6122 17.6978 13.0017 16.0603 12.4821C15.6382 12.3482 15.1625 12.4146 14.8493 12.7278"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="square"
    />
    <path
      d="M12.7281 10.6066L3.82178 19.5129C3.69037 19.6443 3.74319 19.8681 3.9195 19.9269L8.50999 21.457C8.67188 21.511 8.83905 21.3905 8.83905 21.2199L8.83905 18.8418C8.83905 18.7755 8.86539 18.7119 8.91227 18.6651L9.45777 18.1196C9.51341 18.0639 9.592 18.0377 9.6699 18.0489L11.7357 18.344C11.8863 18.3655 12.021 18.2486 12.021 18.0965L12.021 15.6599C12.021 15.5936 12.0474 15.53 12.0943 15.4831L14.8495 12.7279"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M19.2566 8.64982C19.4348 7.98258 19.2621 7.24115 18.7387 6.71769C18.2152 6.19423 17.4738 6.0216 16.8066 6.19978"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);